import jsPDF from 'jspdf';
import QRCode from 'qrcode';
import logoImage from '../assets/so_coffee_logo.png';

const ENVIRONMENT = import.meta.env.APP_ENV;
const BASE_URL =
  ENVIRONMENT === 'production'
    ? 'https://socoffee.mooo.com/api-server/Lot/v1.0/lot/get-lot-info-by-scan'
    : 'https://socoffeedev.orderstack.co/api-server/Lot/v1.0/lot/get-lot-info-by-scan';

let logoDataUrl = null;

async function loadLogoDataUrl() {
  if (logoDataUrl) return logoDataUrl;

  try {
    const response = await fetch(logoImage);
    const blob = await response.blob();
    logoDataUrl = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
    return logoDataUrl;
  } catch (error) {
    console.error('Error loading logo:', error);
    return null;
  }
}

function formatDate(dateValue) {
  if (!dateValue) return 'N/A';

  const date = new Date(dateValue);

  // Check if date is valid
  if (isNaN(date.getTime())) {
    return 'N/A';
  }

  return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
}

function drawLabelValue(doc, label, value, x, y, valueOffset = 37) {
  doc.setFont('helvetica', 'bold');
  doc.text(label, x, y);

  doc.setFont('helvetica', 'normal');
  doc.text(value, x + valueOffset, y);
}

async function getImageDimensions(dataUrl) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      resolve({ width: img.naturalWidth, height: img.naturalHeight });
    };
    img.onerror = reject;
    img.src = dataUrl;
  });
}

const LOGO_DATA_URL_PROMISE = loadLogoDataUrl();

export const generateLotDetailQr = async (lotId, lot) => {
  const doc = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: 'a5',
  });

  const qrValue = `${BASE_URL}?lot_id=${lotId}&lot_name=${lot?.lotname}&redirect=true`;

  const qrDataUrl = await QRCode.toDataURL(qrValue, {
    margin: 1,
    width: 300,
  });

  // ---- QR IMAGE ----
  doc.addImage(qrDataUrl, 'PNG', 5, 10, 80, 80);

  // ---- TEXT CONTENT ----
  let x = 95;
  let y = 20;

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(16);
  doc.text(lot?.lotname, x, y);

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(16);

  // Estate
  y += 10;
  drawLabelValue(doc, 'Estate:', lot?.estate?.name, x, y);

  // Varietal
  y += 10;
  drawLabelValue(doc, 'Varietal:', lot?.varietal, x, y);

  // Harvest Date
  y += 10;
  drawLabelValue(doc, 'Harvest Date:', formatDate(lot?.date_of_harvest), x, y);

  // Drying end date
  y += 10;
  drawLabelValue(doc, 'Drying end:', formatDate(lot?.drying_lot?.drying_end_time) || 'N/A', x, y);

  // Logo
  const logoDataUrl = await LOGO_DATA_URL_PROMISE;

  if (logoDataUrl) {
    const logoDimensions = await getImageDimensions(logoDataUrl);
    const aspectRatio = logoDimensions.width / logoDimensions.height;

    const logoWidth = 45;
    const logoHeight = logoWidth / aspectRatio;
    doc.addImage(logoDataUrl, 'PNG', 155, 75, logoWidth, logoHeight);
  }

  doc.save(`lot-${lot?.lotname}.pdf`);
};
